import { render, staticRenderFns } from "./MyPostList.vue?vue&type=template&id=40aeb51e&scoped=true&"
import script from "./MyPostList.vue?vue&type=script&lang=js&"
export * from "./MyPostList.vue?vue&type=script&lang=js&"
import style0 from "./MyPostList.vue?vue&type=style&index=0&id=40aeb51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aeb51e",
  null
  
)

export default component.exports